class DashboardProfileCtrl {
    showRemoveAccountAlert() {
        let status = confirm(Translator.trans('alert.remove_account_confirmation_question'));

        if(!status) {
            return;
        }

        $('form[name="form"]').submit();
    }
}
export default DashboardProfileCtrl;
